import { defineStore } from "pinia";

interface Page {
    id: number;
    slug: string;
    title: string;
    route_name: string;
    relative_url: string;
    order: string;
}

interface Navigation {
    header: {
        sticky: boolean;
    };
    slideout: {
        visible: boolean;
    };
}

interface AppStore {
    appName: string;
    navigation: Navigation;
    project: string | null;
}

export const useAppStore = defineStore("app", {
    state: () => {
        return {
            appName: "Laud",
            navigation: {
                header: {
                    sticky: false,
                },
                slideout: {
                    visible: false,
                },
            },
            project: null,
        } as AppStore;
    },
});
